import { Utils } from "@/plugins/utils"
import router from "@/router"

export default {
	namespaced: true,
	state: {
		lstOfv: [],
		ofv: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		lastUpdatedRegister: null,
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getOfv(state) {
			let ofv = { ...state.ofv }
			return ofv
		},
		getOfvtanque(state) {
			return state.ofv.ofvtanque
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
	},
	mutations: {
		set(state, ofv) {
			state.ofv = ofv
			if (ofv) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.ofv = null
		},
		setParamsDataTable(state, payload) {
			state.lstOfv = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setOfv(state, ofv) {
			state.ofv = ofv
		},
		setLstOfv(state, lstOfv) {
			state.lstOfv = lstOfv
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setSearch(state, search) {
			state.search = search
		},
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async search({ commit, getters, dispatch }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")
			let payload = await this._vm.$axios
				.get(`/OryxPlace/RawMaterialTank/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					commit("setLstOfv", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async find({ commit, dispatch }, ofvtanque) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/OryxPlace/RawMaterialTank/Find/${ofvtanque}`)
				.then(response => {
					let ofv = Utils.ValidateAxiosResponse(response.data)
					commit("set", ofv)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async get({ dispatch }, ofvtanque) {
			return await this._vm.$axios
				.get(`/OryxPlace/RawMaterialTank/Find/${ofvtanque}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async save({ getters, dispatch }) {
			if (getters.getUpdate) {
				return await dispatch("update")
			}
			return await dispatch("insert")
		},
		async insert({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.post("/OryxPlace/RawMaterialTank/Insert", getters.getOfv)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					commit("setOfv", null)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.put("/OryxPlace/RawMaterialTank/Update", getters.getOfv)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete(`/OryxPlace/RawMaterialTank/Delete/${getters.getOfvtanque}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/tanques-de-materia-prima")
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
	},
}
